import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { api, Auth } from '../api';
import { Authenticator } from './Auth/Authenticator';
import { ListGroup, Button, Modal, Image } from 'react-bootstrap';
import { ReviewCreator } from './ReviewCreator';
import { NavLink } from 'react-router-dom';
import { ItemReviewListItem } from './ItemReview';
import { Spacer, getCloudinaryUrlFromKey } from './Helpers';

function FavoriteItemButton(props) {
    const handleSetFavoriteButtonClick = useCallback(() => {
        async function setFav() {
            try {
                await Auth.currentAuthenticatedUser();
                await api.updateMe({ favItemId: props.itemId });
            } catch (err) {
                console.warn("Failed to set favorite item", err);
            }
        }
        setFav();
    }, [props.itemId]);

    return (
        <Fragment>
        { props.authState === 'signedIn' &&
            <Button variant="primary" onClick={handleSetFavoriteButtonClick} style={{ float: "right"}}>Set as favorite doughnut</Button>
        }
        </Fragment>
    );
}

function ReviewableItemReviewListItems(props) {
    if(!props.reviews) {
        return <Fragment></Fragment>;
    }
    return props.reviews.map(function(review) {
        return (
            <ListGroup.Item key={review.id} style={{display: "inline-block", paddingLeft: "0px", paddingRight: "0px", paddingBottom: "0px", marginBottom: "48px"}}>
                <ItemReviewListItem review={review} showItemLink={false} showUserLink={true} showVendorLink={true} showVendorMap={false} showFullReview={false}/>
            </ListGroup.Item>
        );
    });
}

function ReviewableItemReviewList(props) {
    const [showAddReview, setShowAddReview] = useState(false);

    const onAddReviewClicked = useCallback(() => {
        setShowAddReview(true);
    }, []);
    const handleAddReviewModalClosed = useCallback(() => {
        setShowAddReview(false);
    }, []);

    if (!props.reviewableItem) {
        return <Fragment></Fragment>;
    }

    const reviews = props.reviewableItem.reviews || [];
    return (
        <Fragment>
            <h4 style={{display: "inline-block"}}>Reviews</h4>
            { props.authState === 'signedIn' &&
                <Fragment>
                    <Button onClick={onAddReviewClicked}
                        style={{display: "inline-block", verticalAlign: "text-bottom", marginLeft: "6px"}}>
                        Add Review</Button>
                    <Spacer height="36px"/>
                    <Modal show={showAddReview} onHide={handleAddReviewModalClosed}>
                        <Modal.Header closeButton>
                        </Modal.Header>
                        <Modal.Body>
                            <ReviewCreator itemId={props.reviewableItem.id} item={props.reviewableItem} onReviewCompleted={handleAddReviewModalClosed}/>
                        </Modal.Body>
                    </Modal>
                </Fragment>
            }
            { reviews.length > 0 &&
                <ListGroup style={{maxWidth: "1002px"}}>
                    <ReviewableItemReviewListItems reviews={reviews}></ReviewableItemReviewListItems>
                </ListGroup>
            }
        </Fragment>
    );
}

class ReviewableItem extends React.Component {
    constructor() {
        super();
        this.state = { showAddReview: false };
    }

    handleAddReviewModalClosed() {
        this.setState({ showAddReview: false });
    }

    getImage() {
        if(!this.props.item.photo) {
            return <Fragment></Fragment>;
        }
        return (
            <Fragment>
                <Image src={getCloudinaryUrlFromKey(this.props.item.photo.key, 400)} />
            </Fragment>
        );
    }

    render() {
        if(!this.props.item) {
            return <div></div>;
        }
        return (
            <Fragment>
                <div style={{ padding: "24px 48px 24px 48px", marginTop: "100px", marginBottom: "100px" }}>
                    <div style={{display: "inline-block"}}>
                        <h1 style={{display: "inline-block"}}>{this.props.item.name}</h1>
                    </div>
                    {this.props.item.vendor &&
                        <div className="headerTextLight">by <NavLink to={`/v/${this.props.item.vendor.id}`}>{this.props.item.vendor.name}</NavLink></div>
                    }
                    <p style={{marginTop: "12px"}}>{this.props.item.description}</p>
                    <Authenticator hideDefault="true">
                        <FavoriteItemButton itemId={this.props.item.id} />
                    </Authenticator>
                    <div style={{height: "36px", borderTop: "1px solid #456" }}/>
                    {this.getImage()}
                    <ReviewableItemReviewList
                        reviewableItem={this.props.item}
                        handleAddReviewModalClosed={this.handleAddReviewModalClosed.bind(this)}
                        authState={this.props.authState} ></ReviewableItemReviewList>
                </div>
            </Fragment>
        );
    }
}

class ReviewableItemListItem extends React.Component {
    constructor() {
        super();
        this.state = { showAddReview: false };
    }

    onAddReviewClicked() {
        this.setState({ showAddReview: true });
    }
    handleAddReviewModalClosed() {
        this.setState({ showAddReview: false });
    }

    getReviewCreator() {
        return (
            <Fragment>
                <ReviewCreator item={this.props.item} vendor={this.props.vendor} onReviewCompleted={this.handleAddReviewModalClosed.bind(this)}/>
            </Fragment>
        );
    }

    getAddReviewButton() {
        return (
            <Fragment>
            { this.props.authState === 'signedIn' &&
                <Fragment>
                    <Button style={{display: "inline-block", marginLeft: "6px", verticalAlign: "text-bottom"}} onClick={this.onAddReviewClicked.bind(this)}>Add Review</Button>
                    <Modal show={this.state.showAddReview} onHide={this.handleAddReviewModalClosed.bind(this)}>
                        <Modal.Header closeButton>
                        </Modal.Header>
                        <Modal.Body>
                            {this.getReviewCreator()}
                        </Modal.Body>
                    </Modal>
                </Fragment>
            }
            </Fragment>);
    }

    render() {
        if(!this.props.item) {
            return <div></div>;
        }
        return (
            <Fragment>
                <div style={{ padding: "24px 12px 24px 12px", marginTop: "0px", marginBottom: "0px" }}>
                    <h5 style={{display: "inline-block"}}><NavLink to={`/d/${this.props.item.id}`}>{this.props.item.name}</NavLink></h5>
                    {this.getAddReviewButton()}
                    <p>{this.props.item.description}</p>
                </div>
            </Fragment>
        );
    }
}

function ReviewableItemLoader(props) {
    const [reviewableItem, setReviewableItem] = useState(null);

    useEffect(() => {
        api.getItem(props.id).then(setReviewableItem).catch(() => setReviewableItem(null));
    }, [props.id]);

    return (
        <Fragment>
            <Authenticator hideDefault="true">
                <ReviewableItem item={reviewableItem}></ReviewableItem>
            </Authenticator>
        </Fragment>
    );
}

export { ReviewableItemLoader, ReviewableItem, ReviewableItemListItem };
